import { useEffect } from 'react';
import classNames from 'classnames/bind';
import styles from './StudentRegistration.module.css';

import {
  STUDENT_REGISTRATION_REQUEST,
  STUDENT_REGISTRATION_REQUEST_DESC,
} from '../../../constants';
import Table from '../Table';

import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
import {
  reqListChanged,
  reqPageChanged,
  selectReqList,
  selectReqPage,
  selectReqSortDir,
} from '../../../features/settingsSlice';
import {
  settingsApiSlice,
  useGetRegistrationRequestQuery,
} from '../../../services/settings';

export default function StudentRegistration() {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();

  const page = useAppSelector(selectReqPage);
  const sortDir = useAppSelector(selectReqSortDir);
  const reqList = useAppSelector(selectReqList);

  const [getReqList] = settingsApiSlice.useLazyGetRegistrationRequestQuery();
  const { data, isLoading } = useGetRegistrationRequestQuery({
    page: 0,
    sortDir,
  });

  const updateList = async () => {
    try {
      const res = await getReqList({
        page,
        sortDir,
      }).unwrap();
      dispatch(reqListChanged(res));
    } catch (error) {
      console.error('Fail to get list', error);
    }
  };

  useEffect(() => {
    updateList();
  }, [page, sortDir]);

  useEffect(() => {
    dispatch(reqPageChanged(0));
  }, [dispatch]);

  if (isLoading) return null;

  return (
    <>
      <h2>{STUDENT_REGISTRATION_REQUEST}</h2>
      <p className={cx('fs16', 'tac')}>
        <span
          dangerouslySetInnerHTML={{
            __html: STUDENT_REGISTRATION_REQUEST_DESC,
          }}
        ></span>
      </p>

      <Table name="studentRegistration" list={reqList} />
    </>
  );
}
